<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>REFUND POLICY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Refund Policy</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">
        <p>In case of withdrawal of Admission after Full/Partial Fee Payment, the One-Time Admission charges (Inclusive
            of Security Amount) mentioned in the Fee Structure will be deducted by the University. (Vide UGC Letter no.
            D.O. No.1-3/2007(CPP-II) Dated: 6th December, 2016.</p>

        <table class="table table-responsive table-bordered">
            <thead style="background-color: #e67e22;color: white;">
            <tr>
                <th class="text-white bg-secondary">S.No</th>
                <th class="text-white bg-secondary">Percentage of Refund of Aggregate fee (^)</th>
                <th class="text-white bg-secondary">Point of time when notice of withdrawal of admission is served to
                    Head Admission Committee
                </th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:#e67e22; font-weight: bold;">
            <tr>
                <td>1</td>
                <td>100% (10% deduction as processing charges)</td>

                <td>15 days before the formally noticed last date of admission.</td>
            </tr>

            <tr>
                <td>2</td>
                <td>80%</td>

                <td>Not more than 15 days after the formally noticed last date of admission.</td>
            </tr>

            <tr>
                <td>3</td>
                <td>50%</td>

                <td>More than 15 days but less than 30 days after formally noticed last date of admission.</td>
            </tr>

            <tr>
                <td>4</td>
                <td>0%</td>

                <td>More than 30 days after formally noticed last date of admission.</td>
            </tr>

            </tbody>
        </table>
        <p>*(Inclusive of course fee and non-tuition fee but exclusive of caution money and security deposit)</p>
    </div>
</section>
